import { ZETRIX_RESPONSE_MESSAGE } from "./requestEnum";
import {
  mainChainId,
  chainIdMessage,
  testChainIdMessage,
  switchAccountIdMessage,
} from "./dictionary";
import { mapMutations } from "vuex";
import ZetrixWalletConnect from "zetrix-connect-wallet-sdk";
import { isMobile, isChrome } from "./util";

export default {
  data() {
    return {
      ztx: window.zetrix,
      isMobile: false,
      isChrome: false,
      zetrixWalletConnect: new ZetrixWalletConnect({ qrcode: false }),
      zetrixAccount: sessionStorage.getItem("zetrixAccount"),
      balance: this.$store.state.balance,
      isLogin: sessionStorage.getItem("isLogin"),
      errorNetwork: "",
    };
  },

  watch: {
    ztx: {
      deep: true,
      handler: function () {
        this.ztx.on("chainChanged", (res) => {
          if (res.code === 0) {
            this.setChainId(res.data.chainId);
            if (!this.isMainNetwork()) {
              this.disconnectWalletZtx();
            }
          }
        });
        this.ztx.on("switchAccount", (res) => {
          if (res.code === 0) {
            this.zetrixAccount = res.data.address;
            if (
              this.zetrixAccount !== sessionStorage.getItem("zetrixAccount")
            ) {
              this.getAccountBalance(this.zetrixAccount);
              sessionStorage.clear();
              sessionStorage.setItem("zetrixAccount", this.zetrixAccount);
              // this.setHeaderMessage({
              //   show: true,
              //   message: switchAccountIdMessage,
              // });
              this.isLogin = "true";
              sessionStorage.setItem("isLogin", this.isLogin);
              setTimeout(() => {
                window.location.href = "/#/dashboard";
              }, 2000);
            }
          }
        });
      },
    },
  },

  mounted() {
    this.isMobile = isMobile();
    this.isChrome = isChrome();
    this.checkBalanceZTX();
    this.checkMobileApp();
  },

  updated() {
    this.checkWindowZetrix();
  },

  methods: {
    ...mapMutations([
      "setLogin",
      "setHeaderMessage",
      "setChainId",
      "setBalance",
    ]),

    checkWindowZetrix() {
      if (typeof window.zetrix !== "undefined") {
        this.ztx = window.zetrix;
      }
    },

    checkMobileApp() {
      if (this.isMobile || !this.isChrome) {
        this.zetrixWalletConnect.connect();
      }
    },

    checkBalanceZTX() {
      if (this.zetrixAccount !== null) {
        this.getAccountBalance(this.zetrixAccount);
      }
    },

    // 检查zetrix是否安装
    checkZetrixInstall() {
      if (this.isMobile) {
        // use connect wallet
        this.connectWalletMobileZetrix();
      } else if (this.isChrome) {
        if (typeof window.zetrix === "undefined") {
          alert("Zetrix Wallet not detected, please install and try again");
          if (
            window.confirm(
              "Proceed to open download page for Zetrix wallet extension?"
            )
          ) {
            window.open(
              "https://chrome.google.com/webstore/detail/zetrix-wallet-extension/faobkiaokccpmnhhefnobkbhnfjmbemh/"
            );
          }
        } else {
          this.ztx = window.zetrix;
          this.ztx.getChainId((res) => {
            if (res.code === 0) {
              this.setChainId(res.data.chainId);
              this.sendClientAuthorize();
            }
          });
        }
      } else {
        this.zetrixWalletConnect = new ZetrixWalletConnect({ qrcode: true });
        this.connectWalletMobileZetrix();
      }
    },

    sendClientAuthorize() {
      if (!this.isMainNetwork()) {
        this.$store.dispatch("triggerSnackbar", this.errorNetwork);
        return false;
      }
      this.ztx.authorize({ method: "changeAccounts" }, (resp) => {
        if (resp.code === 0) {
          this.ztx.authorize(
            { method: "sendRandom", param: { random: "blob" } },
            (resAuth) => {
              if (resAuth.code === 0) {
                sessionStorage.setItem("zetrixAccount", resp.data.address);
                this.zetrixAccount = resp.data.address;
                this.getAccountBalance(this.zetrixAccount);
                this.isLogin = "true";
                sessionStorage.setItem("isLogin", this.isLogin);
                window.location.href = "/#/dashboard";
              }
            }
          );
        } else {
          switch (resp.code) {
            case 1:
              alert(ZETRIX_RESPONSE_MESSAGE.CANCEL);
              break;
            case -1:
              alert(ZETRIX_RESPONSE_MESSAGE.FAIL);
              break;
            case 100001:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100001);
              break;
            case 100002:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100002);
              break;
            case 100003:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100003);
              break;
            case 100004:
              alert(ZETRIX_RESPONSE_MESSAGE.CODE100004);
              break;
          }
        }
      });
    },

    isMainNetwork() {
      const chainId = this.$store.state.chainId;
      const host = `${window.location.protocol}//${window.location.host}`;
      const url = process.env.VUE_APP_API_BASE_URL;

      if (
        (host.includes("localhost") ||
          host.includes("test") ||
          url.includes("localhost") ||
          url.includes("test")) &&
        chainId === mainChainId
      ) {
        this.setHeaderMessage({
          show: true,
          message: testChainIdMessage,
        });
        this.errorNetwork = testChainIdMessage;
        return false;
      } else if (
        !host.includes("localhost") &&
        !host.includes("test") &&
        !host.includes("dev") &&
        !url.includes("localhost") &&
        !url.includes("test") &&
        !url.includes("dev") &&
        chainId !== mainChainId
      ) {
        this.setHeaderMessage({
          show: true,
          message: chainIdMessage,
        });
        this.errorNetwork = chainIdMessage;
        return false;
      }
      this.setHeaderMessage({
        show: false,
        message: "",
      });
      return true;
    },

    connectWalletMobileZetrix() {
      this.zetrixWalletConnect
        .connect()
        .then((res) => {
          this.zetrixWalletConnect
            .auth()
            .then((res) => {
              sessionStorage.setItem("zetrixAccount", res.data.address);
              this.zetrixAccount = res.data.address;
              this.getAccountBalance(this.zetrixAccount);
              this.isLogin = "true";
              sessionStorage.setItem("isLogin", this.isLogin);
              window.location.href = "/#/dashboard";
            })
            .catch(() => {
              return false;
            });
        })
        .catch(() => {
          return false;
        });
    },

    getAccountBalance(zetrixAccount) {
      this.$store
        .dispatch("wallet/getAccountBalance", { zetrixAccount: zetrixAccount })
        .then((response) => {
          if (response != null) {
            this.setBalance(response.balance);
            this.balance = response.balance;
          } else {
            this.setBalance(0);
            this.balance = 0;
          }
        });
    },

    signBlob(blob) {
      return new Promise((resolve) => {
        setTimeout(() => {
          if (typeof this.ztx !== "undefined") {
            this.ztx.signMessage({ message: blob }, function (result) {
              if (result.code === 0) {
                return resolve(result);
              }
              return resolve(false);
            });
          } else {
            return resolve(false);
          }
        }, 0);
      });
    },

    signBlobMobileZtx(blob) {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.zetrixWalletConnect
            .signBlob({ message: blob })
            .then((res) => {
              if (res.code === 0) {
                return resolve(res);
              } else {
                return resolve(false);
              }
            })
            .catch((e) => {
              return resolve(false);
            });
        }, 0);
      });
    },

    disconnectWalletZtx() {
      if (this.isMobile || !this.isChrome) {
        this.zetrixWalletConnect.disconnect();
      }
      window.location.href = "/";
      sessionStorage.clear();
    },
  },
};
